import { Badge } from "@/components/ui";
import type { AiAssistNoticeDefinition } from "@/lib/legal-notices";

export function AiAssistNotice({
  notice,
  compact = false,
}: {
  notice: AiAssistNoticeDefinition;
  compact?: boolean;
}) {
  return (
    <div className="rounded-2xl border border-teal-200 bg-teal-50 px-4 py-3 text-sm leading-6 text-teal-950">
      <div className="flex flex-wrap items-center gap-2">
        <Badge tone={notice.status === "active" ? "teal" : "neutral"}>
          {notice.id} v{notice.version}
        </Badge>
        <p className="font-bold">{notice.short}</p>
      </div>
      {compact ? null : <p className="mt-2 text-teal-900">{notice.body}</p>}
    </div>
  );
}
